module.exports = __webpack_public_path__ + "static/media/SellkeyFunction03.7590f3f3.png";